import { useEffect, useState } from 'react';

// Useful for triggering something once when a value changes from falsy to truthy
export default function useTrigger(fire) {
  const [trigger, setTrigger] = useState();

  useEffect(() => {
    if (fire) {
      setTrigger(true);
    }
  }, [fire]);

  useEffect(() => {
    if (trigger) {
      setTrigger(false);
    }
  }, [trigger]);

  return trigger;
}
